import { mapMutations, mapActions } from 'vuex'
import { setKey } from '../../assets/utils'
export default {
  data () {
    return {}
  },
  beforeRouteEnter (from, to, next) {
    if (to.path === '/authentication/smallFlowerBase' || to.path === '/repayment/detail' || to.path === '/withdraw/index') {
      next((vm) => {
        window.history.go(-1)
      })
    } else {
      next((vm) => {
      })
    }
  },
  beforeDestroy () {},
  async created () {
    const { token } = this.$route.query
    // 调用接口 
    const item = await this.getPermissions({ token }) // 授权
    if (item.success) {
      setKey('successUrl', item.data.successUrl)
      this.setUserInfo(item.data)
      this.nextStep(item.data, token)
    } else {
      this.$message('授权失败')
      window.history.go(-1)
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapMutations('user', ['setUserInfo']),
    ...mapActions('user', ['getPermissions']),
    // 判断用户下一步走什么流程
    async nextStep (item, token) {
      // 判断OCR
      // if (item.userStep === 'OCR') {
      //     this.$router.push(`/authentication/id?pfrom=xiaohua&backURL=${item.backURL}`)
      // } else 
      if (item.userStep === 'LOAN') {
        document.title = '小花—天美贷'
        this.$router.replace('/withdraw/index')
      } else if (item.userStep === 'REPAY') {
        let params = {
          loanPlatform: 'TMD',
          productCd: 'TMDP',
          orderId: item.orderId // 订单号（颜值贷）
        }
        document.title = '我要还款'
        this.$router.replace({ path: '/repayment/detail', query: params })
      } else if (item.userStep === 'INFO') { // 如果资料未填写
        document.title = '小花—天美贷'
        this.$router.replace(`/authentication/smallFlowerBase`)
      }
    }
  },
  render () {
    return <div/>
  }
}